import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import { issuerReducer } from '../reducers/issuer.reducer';
import { subscriberReducer } from '../reducers/subscriber.reducer';
import { subscriptionTypesReducer } from '../reducers/subscriptionTypes.reducer';
import { AppActions } from './ActionTypes';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

export const rootReducer = combineReducers({
  issuer: issuerReducer,
  subscriber: subscriberReducer,
  subscriptionTypes: subscriptionTypesReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export type AppState = ReturnType<typeof rootReducer>;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk as ThunkMiddleware<AppState, AppActions>)),
);
